import React from 'react'
import ReactDOM from 'react-dom'
import App from './view/App/App'

import { HashRouter } from 'react-router-dom'

import './index.css'

import * as serviceWorker from './serviceWorker'
import AppStore from './view/AppStore'

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <AppStore>
        <App />
      </AppStore>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
